import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import { Box, Card, CardActionArea, CardContent, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router";
import usePageTitle from "@entrilia/shared/hooks/usePageTitle";
import GeneralPageHeader from "../../../common/GeneralPageHeader";
import StandardReportIconAvatar from "./StandardReportIconAvatar.tsx";
import { standardReports } from "./standardReportsDefinitions.tsx";

const StandardReportsPage = () => {
  usePageTitle("Standard Reports");
  const navigate = useNavigate();

  return (
    <Box sx={{ width: "100%" }}>
      <GeneralPageHeader title="Standard Reports" />
      <Stack spacing={1.5} sx={{ maxWidth: "md", mx: "auto", py: 2.5 }}>
        {standardReports.map((report) => (
          <Card key={report.title} variant="outlined">
            <CardActionArea onClick={() => navigate(`./${report.route}`)}>
              <CardContent sx={{ display: "flex", alignItems: "center", gap: 2, "&:last-child": { pb: 2 } }}>
                <StandardReportIconAvatar color={report.iconColor}>
                  <report.Icon />
                </StandardReportIconAvatar>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="subtitle1">{report.title}</Typography>
                  <Typography variant="body1" color="textSecondary">
                    {report.description}
                  </Typography>
                </Box>
                <ChevronRightRoundedIcon color="action" />
              </CardContent>
            </CardActionArea>
          </Card>
        ))}
      </Stack>
    </Box>
  );
};

export default StandardReportsPage;
